import ArticleCardHome from 'Components/article_card_home'
import ButtonMore from '@fdn/button_more'
import ErrorPlaceholder from '@fdn/error_placeholder'
import {handleUrlArticle} from 'Helpers/utils'

const PopularLifestyleArticleDesktop = ({
  title,
  dataArticle,
  is_mobile,
  slug_url,
  section_name,
}) => {
  return (
    <div className="people-lifestyle-article section">
      <div className="section-title-wrapper">
        <h3 className="section-title">{title}</h3>
      </div>
      {Array.isArray(dataArticle) ? (
        dataArticle.length ? (
          <div className="people-lifestyle-article-wrapper">
            {dataArticle.slice(0, 4).map((item, idx) => (
              <ArticleCardHome
                key={idx}
                is_mobile={is_mobile}
                is_sponsored={false}
                font_title={`Josefin Sans, sans-serif`}
                article={Object.assign({
                  category: { name: item.category_slug.replace(/[_]/g, ' ') },
                  date: item.created_at,
                  title: item.title,
                  text: item.excerpt,
                  image: item.image,
                  url: handleUrlArticle(item.url),
                  author: { fullname: item.author.name },
                })}
                url_category={`${
                  process.env.NEXT_PUBLIC_ROOT_DOMAIN
                }/blog/category/${item.category_slug.replace(/[_]/g, '-')}`}
                url_author={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/author/${item.author.username}`}
                type={'type-2'}
              />
            ))}
            <div className="btn-more-wrapper">
              <ButtonMore
                text={'SEE ARTICLES IN ' + title.toUpperCase()}
                font_family={`Josefin Sans, sans-serif`}
                font_size={12}
                font_weight={400}
                color={'#000000'}
                link={process.env.NEXT_PUBLIC_ROOT_DOMAIN + slug_url}
                element_id={'btn-more-article-' + section_name}
              />
            </div>
          </div>
        ) : (
          <div className="people-lifestyle-article-wrapper single">
            <ErrorPlaceholder
              is_mobile={is_mobile}
              icon="https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/editorial/no-data-icon.svg"
              icon_alt="no data icon female daily"
              title="Sorry :("
              text="There’s no data to display"
            />
          </div>
        )
      ) : (
        <div className="people-lifestyle-article-wrapper single">
          <ErrorPlaceholder
            is_mobile={is_mobile}
            icon="https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/editorial/something-wrong-icon.svg"
            icon_alt="wrong icon female daily"
            title="Uh Oh!"
            text="Something went wrong"
          />
        </div>
      )}
      <style>
        {`
          .people-lifestyle-article.section {
            display: flex;
            flex-direction: column;
            align-items: center;
            // margin: 100px 0 60px 0;
          }

          .people-lifestyle-article-wrapper {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-gap: 40px;
          }

          .people-lifestyle-article-wrapper.single {
            grid-template-columns: 1fr;
            grid-gap: 0px;
          }

          .people-lifestyle-article-wrapper .fdn-article-card-desktop-type-2 .article-title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3; 
            -webkit-box-orient: vertical;
          }

          .people-lifestyle-article-wrapper .fdn-article-card-desktop-type-2 .article-image {
            height: 174px;
          }
        `}
      </style>
    </div>
  )
}

export default PopularLifestyleArticleDesktop
